import React, { Component } from "react";
import axios from "axios";
import Serverurl from "./Apiurl";
import {Button,TextField,Box,Typography,Stack,IconButton,Collapse,Alert,Accordion,AccordionSummary,AccordionDetails} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Navigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";


const fieldStyle = {
  backgroundColor: "#f5f6f8",
  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#f5f6f8",
    "& fieldset": {
      borderColor: "#d1d5db",
    },
    "&:hover fieldset": {
      borderColor: "#9ca3af",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 14px !important",
   
    color: "#000",
  },
};

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bu_id: 0,bu_businessname: "",
      bu_phoneno: "",bu_emailid: "",
      bu_phoneno: "",bu_emailid: "",
     loading: false,emailError: "",alertOpen: false,alertMessage: ""
    };
  }

  componentDidMount() {
	  
	  if(localStorage.getItem("GBuserid")==null)
		 {

		   this.setState({
            logredirect: true,
			pagename:'/Businesslogin'
          })
		  }
		  this.apicall();
  }
  apicall() {
  const bu_id = localStorage.getItem("GBuserid"); 
  if (!bu_id) return;

  axios.get(Serverurl + "ajaxbusiness.php?action=getall&bu_id="+ bu_id)
    .then((res) => {
        if (res.data && res.data.length > 0) {
            const myBusiness = res.data[0]; 
            this.setState({
                bu_id: myBusiness.bu_id || 0,
                bu_businessname: myBusiness.bu_businessname || "",
                bu_phoneno: myBusiness.bu_phoneno || "",
                bu_emailid: myBusiness.bu_emailid || "",
            
            });
 
      } else {
        this.setState({
          bu_id: 0,
          bu_businessname: "",
          bu_phoneno: "",
          bu_emailid: "",
       
        });
      }
    })  
}



  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "bu_phoneno") {
      this.setState({ [name]: value.replace(/\D/g, ""), emailError: "" });
    } else {
      this.setState({ [name]: value, emailError: "" });
    }
	 

  };

  handleSave = () => {
  let firstError = "";
const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/; 
 

if (!this.state.bu_businessname.trim()) firstError = "Business Name is Required";
if (!this.state.bu_phoneno) {
  firstError = "Phone number is required.";
} 

else if (!/^\d{10}$/.test(this.state.bu_phoneno)) {
  firstError = " Please Enter 10 Digits Phone Number."; 
}
if (!this.state.bu_emailid) {
  firstError = "Please Enter Emailid.";
} 

else if (!remail.test(this.state.bu_emailid)) {
  firstError = "Please Enter Valid Emailid."; 
}


  if (firstError) {
    this.setState({ alertOpen: true, alertMessage: firstError, alertSeverity: "error" });
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  this.setState({ alertOpen: false, loading: true });

  const formData = new FormData();
  formData.append("action", "insertorupdateprofile");
  formData.append("bu_id", this.state.bu_id);
  
  formData.append("bu_businessname", this.state.bu_businessname);
  formData.append("bu_phoneno", this.state.bu_phoneno);
  formData.append("bu_emailid", this.state.bu_emailid);
    formData.append("userid",localStorage.getItem("GBuserid"));

  axios.post(Serverurl + "ajaxbusiness.php", formData)
    .then((res) => {
      this.setState({
        alertOpen: true,
        alertMessage: "Profile saved successfully",
        alertSeverity: "success",
        loading: false,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    })
   
};
goBack = () => {
  window.history.back();
};

  render() {
	   if (this.state.redirect === true) {
    return <Navigate to={this.state.pagename} />;
  }
  
    return (
	<div className="formdisplay">

	 
 
 <div className="boxheading">
  <div className="heading-with-back">
              <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
    <h2>Profile</h2>
  </div>
</div>
        <p><Collapse in={this.state.alertOpen}>
          <Alert
            severity={this.state.alertSeverity}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => this.setState({ alertOpen: false, alertMessage: "" })}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {this.state.alertMessage}
          </Alert>
        </Collapse></p>

       
      
 <p><TextField
    fullWidth
    size="small"
	label="Business Name"
    name="bu_businessname"
     placeholder="Business Name"
    value={this.state.bu_businessname}
    onChange={this.handleChange}
	sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
/></p>

<p><TextField label="Email" name="bu_emailid"  placeholder="Email"  type="email" inputProps={{ maxLength: 150 }} value={this.state.bu_emailid} onChange={this.handleChange} error={Boolean(this.state.emailError)} helperText={this.state.emailError} fullWidth
sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }} /></p>
 <p><TextField label="Phone No." name="bu_phoneno"  placeholder="Phone No."  inputProps={{ maxLength: 10 }} value={this.state.bu_phoneno} onChange={this.handleChange} fullWidth 
 sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}/></p>      

     <p className="aligncenter">     <Button variant="contained" className="primartybtn" onClick={this.handleSave} disabled={this.state.loading}
	         		  sx={{
   
    borderRadius: "20px",
    minWidth: "110px",
  }}>
            {this.state.loading ? "Saving..." : "Save"}
          </Button>
</p>
   
	  </div>
    );
  }
}
